import { fork } from 'redux-saga/effects';

import { mfaRequiredSaga } from './mfaRequiredSaga';
import { toastSaga } from './toastSaga';
import { confirmationSaga } from './confirmationSaga';
import { tournamentsSaga } from './tournamentsSaga';
import { bulkTransferSaga } from './bulkTransferSaga';
import { leaderboardSaga } from './leaderboardSaga';

export default function* rootSaga() {
  yield fork(mfaRequiredSaga);
  yield fork(toastSaga);
  yield fork(confirmationSaga);
  yield fork(tournamentsSaga);
  yield fork(bulkTransferSaga);
  yield fork(leaderboardSaga);
}
